import { render, staticRenderFns } from "./ColumnConfig.vue?vue&type=template&id=38abf686&"
import script from "./ColumnConfig.vue?vue&type=script&lang=ts&"
export * from "./ColumnConfig.vue?vue&type=script&lang=ts&"
import style0 from "./ColumnConfig.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports